import { connect } from 'react-redux';
import CancelReservation from './CancelReservation';
import { closeCancelReservationScreen, fetchReservation, cancelReservation } from '../../actions/cancelling';
import { clearSession } from '../../actions/session';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  fetchingReservationError: state.cancelling.fetchingReservationError,
  reservation: state.cancelling.reservation,
  cancellingReservationError: state.cancelling.cancellingReservationError,
  reservationCancelled: state.cancelling.reservationCancelled,
  resources: state.resources,
  units: state.units,
  reservationWasAlreadyCancelled: state.cancelling.reservationAlreadyCancelled
});
const mapDispatchToProps = dispatch => ({
  closeCancelReservationScreen() {
    dispatch(closeCancelReservationScreen());
  },
  fetchReservation: dispatch(fetchReservation),
  cancelReservation: dispatch(cancelReservation),
  logout: dispatch(clearSession)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelReservation);



// WEBPACK FOOTER //
// ./src/containers/CancelReservation/index.js